const classes = {
	component: `ConversationCard`,
	chatCtas: 'ConversationCard--openChat',
	pageChatButton: 'web-messenger-container',
};

const selectors = {
	component: `.${classes.component}`,
	chatCtas: `.${classes.chatCtas}`,
	pageChatButton: `#${classes.pageChatButton}`,
};

export default function initAllConversationsCards() {
	initConversationCardsUnder('body');
}

export const initConversationCardsUnder = selector => {
	//setup chat, if available
	$(`${selector} ${selectors.chatCtas} a`).on('click', e => {
		e.preventDefault();
		window.dispatchEvent(new Event('webchat.open'));
	});

	$(`${selector} ${selectors.component}`).each(function () {
		const $component = $(this);
		const trackInteractions = $component.data('trackInteractions');
		if (trackInteractions) {
			$component.find('a').on('click', function () {
				const $link = $(this);
				//this is pretty terrible. Basically interaction tracking will only work with Icon Links with this approach
				const linkText = $link.find('.QuickLinks-link--text').text();

				if (linkText) {
					window.FS.Tealium.trackInteraction(trackInteractions, linkText, '');
				}
			});
		}
	});

	//hide if chat is not enabled
	if (!getPageChatButton()) {
		$(`${selector} ${selectors.chatCtas}`).hide();
	}
};

const getPageChatButton = () => document.querySelector(selectors.pageChatButton);
